import { FC, useLayoutEffect } from "react";
import styled from 'styled-components';
import { DatePicker as ADatePicker, DatePickerProps } from "@atlaskit/datetime-picker";
import Spinner from '@atlaskit/spinner';
import { Box } from "../Box";

import "./CustomDatePicker.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const SpinnerContainer = styled.div`
  position: relative;
  span {
    position: absolute;
    top: 55%;
    margin-top: 5px;
    z-index: 1000;
    left: 45%;
  }
`;

interface CustomProps {
  label?: string;
  customWidth?: string;
  isLoading?: boolean;
}

export const DatePicker: FC<DatePickerProps & CustomProps> = (props) => {
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up("sm"));
  useLayoutEffect(() => {
    const inputDatepicker = document.querySelectorAll(".custom-date-picker input[type=text]");
    if (!isUpSm && inputDatepicker.length > 0) {
      inputDatepicker.forEach((input) => input.setAttribute("inputmode", "none"));
    }
  }, [isUpSm]);
  return (
    <Box width={props.customWidth? props.customWidth : 200}>
      <small>{props.label}</small>
        {props.isLoading &&
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        }
        <ADatePicker {...props} placeholder="Select a date" />
    </Box>
  );
};
